const BASE_URL = 'https://vxtvtnu04i.execute-api.us-east-1.amazonaws.com/dev/';
const BASE_URL_PROD = 'https://64tbzyvgd5.execute-api.us-east-1.amazonaws.com/prod/';

const DESCONTOS_URL = 'https://c8vq74tje6.execute-api.us-east-1.amazonaws.com/dev/';
const DESCONTOS_URL_PROD = 'https://xxbw55snie.execute-api.us-east-1.amazonaws.com/prod/';

const ANIVERSARIO_URL = 'https://4v1weklmvg.execute-api.us-east-1.amazonaws.com/dev/';
const ANIVERSARIO_URL_PROD = 'https://hpdm1oqxn7.execute-api.us-east-1.amazonaws.com/prod/';

const NOTIFICATIONS_URL = 'https://p8jkwqcbn0.execute-api.us-east-1.amazonaws.com/dev/';
const NOTIFICATIONS_URL_PROD = 'https://nguwgmlfr3.execute-api.us-east-1.amazonaws.com/prod/';

const BASE_ENDPOINT = (window.location.href.search('localhost') != -1 || window.location.href.search('new.click2giv') != 1) ? BASE_URL_PROD : BASE_URL;
const DESCONTOS_ENDPOINT = (window.location.href.search('localhost') != -1 || window.location.href.search('new.click2giv') != 1) ? DESCONTOS_URL_PROD : DESCONTOS_URL;
const ANIVERSARIO_ENDPOINT = (window.location.href.search('localhost') != -1 || window.location.href.search('new.click2giv') != 1) ? ANIVERSARIO_URL_PROD : ANIVERSARIO_URL;
const NOTIFICATIONS_ENDPOINT = (window.location.href.search('localhost') != -1 || window.location.href.search('new.click2giv') != 1) ? NOTIFICATIONS_URL_PROD : NOTIFICATIONS_URL;

const API = {
  Auth: {
    "register": BASE_ENDPOINT + 'click2giv/users/register',
    "forgotPassword": BASE_ENDPOINT + 'click2giv/users/forgot-password',
    "login": BASE_ENDPOINT + 'click2giv/users/login',
    "loginFacebook": BASE_ENDPOINT + 'click2giv/users/loginfacebook',
    "loginGoogle": BASE_ENDPOINT + 'click2giv/users/loginfacebook',
    "confirmEmail": BASE_ENDPOINT + 'click2giv/users/confirm-email'
  },
  Profile: {
    "profile": BASE_ENDPOINT + 'click2giv/users/profile',
    "profileUpdate": BASE_ENDPOINT + 'click2giv/users/profile',
    "partnerUpdate": BASE_ENDPOINT + 'click2giv/users/profile',
    "createCoupon": DESCONTOS_ENDPOINT + 'click2giv/users/coupons/create',
    "projects": BASE_ENDPOINT + 'click2giv/users/projects',
    "donations": BASE_ENDPOINT + 'click2giv/users/donations',
    // "campaigns": ANIVERSARIO_URL + 'click2giv/users/campaigns'
  },
  Projects: {
    "home": BASE_ENDPOINT + 'click2giv/projects/home',
    "projects": BASE_ENDPOINT + 'click2giv/projects/all',
    "categories": BASE_ENDPOINT + 'click2giv/projects/categories',
    "createProject": BASE_ENDPOINT + 'click2giv/users/projects/create',
    "updateProject": BASE_ENDPOINT + 'click2giv/users/projects/',
    "getPrivateProject": BASE_ENDPOINT + 'click2giv/users/projects/',
    "getProject": BASE_ENDPOINT + 'click2giv/projects/',
    "registerDonation": BASE_ENDPOINT + 'click2giv/projects/donation/register',
    "getDonation": BASE_ENDPOINT + 'click2giv/projects/donation/get/',
    "favoriteProject": BASE_ENDPOINT + 'click2giv/projects/favorite/',
    "subscribeProject": BASE_ENDPOINT + 'click2giv/projects/subscribe/',
    "processPaymentPagarme": BASE_ENDPOINT + 'click2giv/projects/donation/payment/pagarme/',
    "processNotificationPagarme": BASE_ENDPOINT + 'click2giv/projects/donation/notification/pagarme/',
    "processPaymentPagseguro": BASE_ENDPOINT + 'click2giv/projects/donation/payment/pagseguro/',
    "processNotificationPagseguro": BASE_ENDPOINT + 'click2giv/projects/donation/notification/pagseguro/',
    "processPaymentPaypal": BASE_ENDPOINT + 'click2giv/projects/donation/payment/paypal/',
    "processNotificationPaypal": BASE_ENDPOINT + 'click2giv/projects/donation/notification/paypal/',
  },
  Coupons: {
    "list": DESCONTOS_ENDPOINT + 'click2giv/coupons/',
    "registerSharedLink": DESCONTOS_ENDPOINT + 'click2giv/coupons/register'
  },
  Contact: {
    "contact": BASE_ENDPOINT + 'click2giv/newsletter/submit',
    "newsletter": BASE_ENDPOINT + 'click2giv/newsletter/submit',
  },
  Invite: {
    "create": ANIVERSARIO_ENDPOINT + 'aniversariodobem/create',
    "get": ANIVERSARIO_ENDPOINT + 'aniversariodobem/',
    "registerDonation": ANIVERSARIO_ENDPOINT + 'aniversariodobem/donation/register',
    "getDonation": ANIVERSARIO_ENDPOINT + 'aniversariodobem/donation/',
    "processPayment": ANIVERSARIO_ENDPOINT + 'aniversariodobem/donation/payment/',
    "processNotification": ANIVERSARIO_ENDPOINT + 'aniversariodobem/donation/notification/',
  },
  Stores: {
    "list": DESCONTOS_ENDPOINT + 'click2giv/stores/all'
  },
  Notifications: {
    "list": NOTIFICATIONS_ENDPOINT + 'notifications/users/list',
    "read": NOTIFICATIONS_ENDPOINT + 'notifications/users/read/',
    "delete": NOTIFICATIONS_ENDPOINT + 'notifications/users/delete/',
    "create": NOTIFICATIONS_ENDPOINT + 'notifications/create'
  }
}


module.exports = {
  API
}



// WEBPACK FOOTER //
// ./src/services/api.js